import request from "services/Request"
import {serializeOrderItemAttachment} from "../../types/OrderItem";

export function postOrderItemAttachment(data) {
    return request({
        url: `/shop/order-item-attachments`,
        method: 'POST',
        headers: {
            'content-type': 'multipart/form-data'
        },
        data
    }, serializeOrderItemAttachment)
}